import React from 'react';
import './WhyOffshoreAdvisory.css'
import {GoDotFill} from "react-icons/go";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import PageList from "../../../components/Constant/List/List";
import Button from "../../../components/Constant/button/Button";
import Hero from '../../../components/home/Hero/Hero';
import whiteArrowIcon from '../../../assets/images/Home/whiteArrow.svg'
import Footer from "../../../components/Layout/Footer/Footer";

import whyOffshoreHeaderImg from '../../../assets/images/whyOffshoreHeader.png'
import { Link } from 'react-router-dom';
import Discover from '../../../components/Discover/Discover';
import OherPractices from '../../../components/OtherPractices/OherPractices';
import ContactFormWithBackground from '../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground';

const breadcrumbs = [
    { name: 'Home', link: '/' },
    { name: 'Why Offshore Advisory', link: '/why-offshore-advisory' },
  ];

function WhyOffshoreAdvisory() {
    return (
        <main className='main'>
            <Hero breadcrumbs={breadcrumbs} contentCenter={true} pretitle='Your Trusted Partner for Global Business, Licensing & Residency Solutions' title='Why Offshore Advisory' descr='Choosing the right partner for offshore structuring, licensing, and residency can make the difference between success and costly delays. At Offshore Advisory, we combine deep expertise, global reach, and client-first service to deliver seamless, compliant, and strategic solutions.' backgroundImg='whyOffshoreHeader'/>
            <section
                className='about-section section'
            >
                
                <div className='why-offshore-background'>
                    <div className='why-choose-us-container'>
                        <div className='why-choose-us-left'>
                            <h2 className='why-choose-us-title'>
                                Why Choose Us?
                            </h2>
                            <span className='why-choose-us-sub-title'>
                                Seamless, compliant, and tailored offshore solutions
                            </span>
                        </div>
                        <div className='why-choose-us-right'>
                            <div className='why-choose-us-item'>
                                <span className='why-choose-us-item-point'>
                                    (01)
                                </span>
                                <h3 className='why-choose-us-item-title'>
                                    Global Expertise Across 20+ Jurisdictions
                                </h3>
                                <p className='why-choose-us-item-descr'>
                                    From Western Sahara, Mwali, and Anjouan to Malta, Cyprus, Panama, UAE, and Singapore, we provide incorporation and licensing solutions in the world’s leading offshore and financial hubs.
                                </p>
                            </div>
                            <div className='why-choose-us-item'>
                                <span className='why-choose-us-item-point'>
                                    (02)
                                </span>
                                <h3 className='why-choose-us-item-title'>
                                    Full-Service Solutions Under One Roof
                                </h3>
                                <p className='why-choose-us-item-descr'>
                                Unlike agencies that only form companies, we provide end-to-end support:
                                <ul>
                                    <li>
                                        Company-formation
                                    </li>
                                    <li>
                                        IBCs, PT PMA, LTDs, PLCs, Subsidiaries.
                                    </li>
                                    <li>
                                        Licensing
                                    </li>
                                    <li>
                                        Banking, Gaming, Brokerage, Crypto, Insurance, Funds.
                                    </li>
                                    <li>
                                        Banking & FinTech
                                    </li>
                                    <li>
                                        Bank accounts, PSP/EMI licenses.
                                    </li>
                                    <li>
                                        Residency & Citizenship
                                    </li>
                                    <li>
                                        Golden Visas, Investor KITAS, UAE Residency.
                                    </li>
                                    <li>
                                        Tax & Asset Protection
                                    </li>
                                    <li>
                                        Non-dom regimes, trusts, corporate structuring.
                                    </li>
                                </ul>
                                </p>
                            </div>
                            <div className='why-choose-us-item'>
                                <span className='why-choose-us-item-point'>
                                    (03)
                                </span>
                                <h3 className='why-choose-us-item-title'>
                                    Compliance & Transparency
                                </h3>
                                <p className='why-choose-us-item-descr'>
                                    We prioritize compliance and regulatory integrity, ensuring every structure or license aligns with international AML/KYC standards. Our transparent pricing and process mean no hidden surprises.
                                </p>
                            </div>
                            <div className='why-choose-us-item'>
                                <span className='why-choose-us-item-point'>
                                    (04)
                                </span>
                                <h3 className='why-choose-us-item-title'>
                                    Tailored Strategies for Every Client
                                </h3>
                                <p className='why-choose-us-item-descr'>
                                Every client is unique. We take the time to understand your:
                                <ul>
                                    <li>
                                        Industry
                                    </li>
                                    <li>
                                        Banking, fintech, iGaming, trading, consulting, and more.
                                    </li>
                                    <li>
                                        Risk Appetite
                                    </li>
                                    <li>
                                        Choose between Tier-1 jurisdictions or cost-efficient offshore options.
                                    </li>
                                    <li>
                                        Goals
                                    </li>
                                    <li>
                                        Licensing, banking, residency, and asset protection solutions tailored to your objectives.
                                    </li>
                                </ul>
                                Then we design a custom solution that fits your vision.
                                </p>
                            </div>
                            <div className='why-choose-us-item'>
                                <span className='why-choose-us-item-point'>
                                    (05)
                                </span>
                                <h3 className='why-choose-us-item-title'>
                                    Recognized & Trusted Network
                                </h3>
                                <p className='why-choose-us-item-descr'>
                                We work directly with:
                                <ul>
                                    <li>
                                        Licensed agents, regulators, and government bodies.
                                    </li>
                                    <li>
                                        Law firms, accountants, and compliance specialists.
                                    </li>
                                    <li>
                                        International banks & payment providers.
                                    </li>
                                </ul>
                                This ensures your company, license, or residency is valid, recognized, and respected worldwide.
                                </p>
                            </div>
                            <div className='why-choose-us-item'>
                                <span className='why-choose-us-item-point'>
                                    (06)
                                </span>
                                <h3 className='why-choose-us-item-title'>
                                    Proven Client Success
                                </h3>
                                <p className='why-choose-us-item-descr'>
                                Hundreds of clients have trusted Offshore Advisory to:
                                <ul>
                                    <li>
                                        Launch iGaming platforms in Curacao, Malta, and Western Sahara.
                                    </li>
                                    <li>
                                        Secure Forex & Brokerage licenses in Cyprus and Seychelles.
                                    </li>
                                    <li>
                                        Establish Banking entities in Mauritius and Panama.
                                    </li>
                                </ul>
                                Obtain Residency permits in Spain, Greece, Italy, and the UAE.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='makes-us-different-container'>
                    <h2 className='makes-us-different-title'>
                        What Makes Us Different?
                    </h2>
                    <div className='makes-us-different-row'>
                        <div className='makes-us-different-upper'>
                            <div className='makes-us-different-upper-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>
                                        Global Reach
                                    </h3>
                                </div>
                                <p className='upper-item-descr'>
                                    20+ jurisdictions covered.
                                </p>
                            </div>
                            <div className='makes-us-different-upper-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>
                                        Trusted Compliance
                                    </h3>
                                </div>
                                <p className='upper-item-descr'>
                                    Aligned with international standards.
                                </p>
                            </div>
                            <div className='makes-us-different-upper-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>
                                        Fast Execution
                                    </h3>
                                </div>
                                <p className='upper-item-descr'>
                                    Efficient incorporation and licensing.
                                </p>
                            </div>
                        </div>
                        <div className='makes-us-different-bottom'>
                            <div className='makes-us-different-bottom-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>
                                        End-to-End
                                    </h3>
                                </div>
                                <p className='upper-item-descr'>
                                    One partner for setup, licensing, banking, and residency.
                                </p>
                            </div>
                            <div className='makes-us-different-bottom-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>
                                        Client-First
                                    </h3>
                                </div>
                                <p className='upper-item-descr'>
                                    Personal, tailored support from day one.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ready-to-get-started-background'>
                    <div className='ready-to-get-started-content'>
                        <h2 className='ready-to-get-started-title'>
                            Ready to Get Started?
                        </h2>
                        <p className='ready-to-get-started-descr'>
                            Partner with Offshore Advisory and unlock opportunities worldwide.
                        </p>
                        <div className='ready-to-get-started-btn'>
                            <Link to='/newsletter' >
                                Free Consultation Today
                                <img src={whiteArrowIcon} />
                            </Link>
                        </div>
                    </div>
                </div>
                <Discover />
                <OherPractices />
                <ContactFormWithBackground />
            </section>
            {/* <Footer /> */}
        </main>
    );
}

export default WhyOffshoreAdvisory;
